import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss']
})
export class TourComponent implements OnInit, AfterViewInit, OnDestroy {
  isVideoActive = false;
  private modalEl: HTMLElement | null = null;
  private hideListener: (() => void) | null = null;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Listen to bootstrap modal close event to stop the video iframe
    this.modalEl = document.getElementById('tourModal');
    if (this.modalEl) {
      this.hideListener = () => {
        this.isVideoActive = false;
        this.cdr.detectChanges();
      };
      this.modalEl.addEventListener('hide.bs.modal', this.hideListener);
    }
  }

  openVideo(): void {
    this.isVideoActive = true;
  }

  ngOnDestroy(): void {
    if (this.modalEl && this.hideListener) {
      this.modalEl.removeEventListener('hide.bs.modal', this.hideListener);
    }
  }
}
